import { render, staticRenderFns } from "./fengrengzMb.vue?vue&type=template&id=859704a2&scoped=true&"
import script from "./fengrengzMb.vue?vue&type=script&lang=js&"
export * from "./fengrengzMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859704a2",
  null
  
)

export default component.exports